module.exports = __webpack_public_path__ + "img/jfOrganizacija.91673fb7.jpg";